import { Dialog } from "@base-ui/react/dialog";
import styles from "./TimeoutDialog.module.css";

interface RecommenderBackDialogProps {
  open: boolean;
  onClose: () => void;
  onGoToQualtrics: () => void;
}

const RecommenderBackDialog = ({
  open,
  onClose,
  onGoToQualtrics,
}: RecommenderBackDialogProps) => {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen && open) {
      onClose();
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Backdrop className={styles.backdrop} />

        <Dialog.Viewport className={styles.viewport}>
          <Dialog.Popup
            className={styles.popup}
            data-cy="recommender-back-dialog"
          >
            <Dialog.Title
              className={styles.title}
              data-cy="recommender-back-dialog-title"
            >
              Reminder
            </Dialog.Title>

            <Dialog.Description className={styles.description}>
              You've visited the MentorPal page. Please complete the Qualtrics
              survey.
            </Dialog.Description>

            <div className={styles.actions}>
              <button
                type="button"
                className={styles.secondaryButton}
                onClick={onClose}
                data-cy="back-button"
              >
                Close
              </button>

              <button
                type="button"
                className={styles.primaryButton}
                onClick={onGoToQualtrics}
                data-cy="go-to-survey-button"
              >
                Go to Qualtrics
              </button>
            </div>
          </Dialog.Popup>
        </Dialog.Viewport>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default RecommenderBackDialog;
